import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, TextField } from 'seagull';
import { agreementNameValidation } from '~/business-logic/validators';
import { useStoreActions } from '~/contexts';
import { useUpdateRelationship } from '~/hooks/useUpdateRelationship';
import { agreementChangeModel } from '~/models';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './RenameAgreementModal.module.scss';
export default function RenameAgreementModal(props) {
    const { relationship, onSuccess, dismissModal } = props;
    const { control, formState, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            title: relationship.title
        }
    });
    const { logBI } = useStoreActions();
    const updateRelationship = useUpdateRelationship();
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: "Rename agreement",
        onCloseButtonClick: dismissModal,
        primaryButtonTestId: "rename-agr",
        primaryButtonDisabled: !formState.isDirty,
        primaryButtonLabel: "Save",
        secondaryButtonLabel: "Cancel",
        onPrimaryButtonClick: handleSubmit(async (param)=>{
            let { title } = param;
            updateRelationship(_object_spread_props(_object_spread({}, relationship), {
                changes: [
                    agreementChangeModel.makeTitleChange(title)
                ],
                onSuccess: ()=>{
                    logBI(14050);
                    onSuccess(title);
                    dismissModal();
                }
            }));
        }),
        onSecondaryButtonClick: dismissModal,
        content: /*#__PURE__*/ _jsx("div", {
            className: styles.content,
            children: /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "title",
                rules: agreementNameValidation,
                render: (p)=>/*#__PURE__*/ _jsx(TextField, _object_spread({
                        collapseHelperText: false,
                        autoFocus: true,
                        testId: "agr-name",
                        label: "Agreement name"
                    }, connectControllerToTextField(p)))
            })
        })
    });
}
